import React, { useContext, useEffect, useRef, useState } from 'react'
import { MobileView } from 'react-device-detect';
import MobileHeader from '../../Components/Elements/mobile_header';
import { ApiService } from "../../Components/Services/apiservices";
import Skeleton from "react-loading-skeleton";
import constant from '../../Components/Services/constant';
import { useNavigate } from "react-router-dom";
import ProductBox from '../../Components/Elements/product_box';
import LoginModal from '../../Components/Modals/login_modal';
import DataContext from '../../Components/Elements/eventContext';
function Category() {
  const navigate = useNavigate()
  const contextValues = useContext(DataContext);
  const didMountRef = useRef(true);
  const [categorydata, setcategorydata] = useState([])
  const [childCategoryData, setChildCategoryData] = useState([])
  const [productsData, setProductsData] = useState([])
  const [childCategoryActive, setChildCategoryActive] = useState(0)
  const [parentCategoryActive, setParentCategoryActive] = useState(0)
  const [catimgpath, setcatimgpath] = useState('')
  const [loading, setloading] = useState(true)
  const [productLoading, setProductLoading] = useState(true)
  const [openCategoryIndices, setOpenCategoryIndices] = useState([]);

  const defaultImg = constant.DEFAULT_IMAGE
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    if (didMountRef.current) {
      getsettingData()
      getcategorydata()
    }
    didMountRef.current = false;
  }, []);

  const getcategorydata = () => {
    ApiService.fetchData(
      "all-categories"
    ).then((res) => {
      if (res.status === "success") {
        const firstCategory = res.allCategories[0]
        const firstChild = firstCategory.children?.[0]

        setcategorydata(res.allCategories);
        setChildCategoryData(firstCategory.children || [])
        setcatimgpath(res.category_image_path || '')
        setParentCategoryActive(firstCategory.cat_id)
        if (firstChild) {
          setChildCategoryActive(firstChild.cat_id)
          getProductByCaterory(firstChild.cat_id)
        }
        setloading(false)
      } else {
        setloading(false)
      }
    }).catch((error) => {
      console.log(error)
      setloading(false)
    });
  }

  const getChildCategoryByParent = (catId = 0) => {
    if (!catId || !categorydata.length) return [];

    const parentCategory = categorydata.find(
      cat => cat.cat_id === catId
    );
    setParentCategoryActive(catId)
    const firstChild = parentCategory.children?.[0]
    setChildCategoryData(parentCategory.children || [])
    if (firstChild) {
      setChildCategoryActive(firstChild.cat_id)
      getProductByCaterory(firstChild.cat_id)
    } else {
      getProductByCaterory(catId)
    }
  }

  const getProductByCaterory = (catId = 0) => {
    setProductLoading(true)
    ApiService.fetchData(
      "getProductByCaterory/" + catId
    ).then((res) => {
      if (res.status === "success") {
        setChildCategoryActive(catId)
        setProductsData(res.data)
        setProductLoading(false)
      } else {
        setProductLoading(false)
      }
    }).catch((error) => {
      setProductLoading(false)
    });
  }

  const getsettingData = () => {
    ApiService.fetchData("settingsdata").then((res) => {
      if (res.status === "success") {
        contextValues.setSettingData(res.sitesettings)
        contextValues.setSettingImageBaseUrl(res.setting_image_path);
      }
    });
  };
  return (
    <>
      <MobileView>
        <MobileHeader
          Route="" PageName="Categories" cartCount={0}
        />
        <div id="appCapsule">
          <div className='appCapsule-category'>
            <ul>
              {categorydata &&
                categorydata.map((item) => (
                  <li
                    className={`${parentCategoryActive === item.cat_id ? 'active' : ''}`}
                    key={item.cat_id}
                    onClick={() => getChildCategoryByParent(item.cat_id)}>
                    <img
                      src={item.cat_image ? catimgpath + item.cat_image : defaultImg}
                      alt={item.cat_name}
                    />{item.cat_name}</li>
                ))
              }
            </ul>
          </div>
          <div className='catlisting-section'>
            <div className='listing-left'>
              <div className="nav flex-column osahan-item-sidebar nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                {childCategoryData &&
                  childCategoryData.map((item, index) => (
                    <button
                      className={`nav-link ${childCategoryActive === item.cat_id ? 'active' : ''}`}
                      key={item.cat_id}
                      onClick={() => getProductByCaterory(item.cat_id)}
                    >
                      <div className="osahan-item">
                        <div className="osahan-item-media">
                          <div className="osahan-item-media-item">
                            <img
                              src={item.cat_image ? catimgpath + item.cat_image : defaultImg}
                              alt={item.cat_name}
                            />
                          </div>
                        </div>
                        <div className="osahan-item-name">{item.cat_name}</div>
                      </div>
                    </button>
                  ))
                }
              </div>
            </div>
            <div className='listing-right' >
              <div className='p-3'>
                {productLoading === true ? (
                  <div className="row g-3 cols-2">
                    {[...Array(9)].map((_, index) => (
                      <div className="cproduct" key={index}>
                        <div className='cproduct-media'>
                          <figure className="cproduct-media-img"></figure>
                        </div>
                        <div className="cproduct-details">
                          <Skeleton variant="text" width={80} />
                          <div className="cproduct-price">
                            <Skeleton variant="text" width={100} />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <>
                    {productsData.length > 0 ? (
                      <div className="row g-3 cols-2" style={{ paddingBottom: '500px' }}>
                        {productsData.map((subvalue, indexProduct) => {
                          return (
                            <ProductBox productValue={subvalue} indexProduct={indexProduct} />
                          );
                        })}
                      </div>
                    ) : (
                      <h2>No products found.</h2>
                    )}
                  </>
                )}
              </div>
            </div>

          </div>
        </div>
      </MobileView>
      <LoginModal />
    </>
  )
}

export default Category